import { render, staticRenderFns } from "./JobPreviewHeaderSp.vue?vue&type=template&id=72cd9d58&scoped=true"
import script from "./JobPreviewHeaderSp.vue?vue&type=script&lang=js"
export * from "./JobPreviewHeaderSp.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewHeaderSp.vue?vue&type=style&index=0&id=72cd9d58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd9d58",
  null
  
)

export default component.exports